import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-des-receipt-page',
  templateUrl: './des-receipt-page.component.html',
  styleUrl: './des-receipt-page.component.scss',
})
export class DesReceiptPageComponent implements OnInit {
  purchaseId?: string;
  tenantId?: string;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.purchaseId = this.route.snapshot.params['id'];
    this.tenantId =
      this.route.snapshot.queryParamMap.get('tenant_id') ||
      this.authService.currentUser?.tenant_id;
  }
}
